import type { Strings } from '../i18n/strings';

// Small formatters for release 3 (0019) screens.

/** Period label "2026-Q3" → "Q3 2026" (same in all three languages). */
export function periodLabel(p: string): string {
  const m = /^(\d{4})-Q(\d)$/.exec(p);
  return m ? `Q${m[2]} ${m[1]}` : p;
}

/** Term label "2026-spring" → "Spring term 2026" in the viewer's language. */
export function termLabel(t: Strings, term: string): string {
  const m = /^(\d{4})-(spring|autumn)$/.exec(term);
  return m ? t[`r3.term.${m[2]}` as 'r3.term.spring'](m[1]) : term;
}

export const TOPICS7 = ['schoolwork', 'friends', 'family', 'sleep', 'health', 'exams', 'other'] as const;
